import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { WorkbookContentType } from '../models/ContentTypes';
import { IWorkbookBase } from '../models/IWorkbookInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Workbooks } from '../resources/Workbooks';
import { IChangeContentTagsAction, IChangeContentTagsResult } from '../ServerApi/types/IChangeContentTagsAction';
import { ChangeTagsActionHelperService } from './ChangeTagsActionHelper';
import { IErrorDetail, INotificationTranslationIds } from './ContentActionNotification';
import { ContentUrlForItem } from './ContentUrl';

export class ChangeWorkbooksTagsAction implements IChangeContentTagsAction {

  public static notificationTranslationIds: INotificationTranslationIds = {
    successId: 'changeTagsWorkbooksSuccess',
    errorId: 'changeTagsWorkbooksError'
  };

  public execute: (itemSet: Set<IWorkbookBase>, actionContext: IActionContext) => ng.IPromise<IChangeContentTagsResult>;

  public static $inject = ['ChangeTagsActionHelperService', '$translate', 'Workbooks'];

  constructor(
    private ChangeTagsActionHelper: ChangeTagsActionHelperService,
    private $translate: ng.translate.ITranslateService,
    private Workbooks: Workbooks,
  ) {
    this.execute = ChangeTagsActionHelper.createExecuteFn<IWorkbookBase>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => this.Workbooks.changeTags(ids, addTags, removeTags),
      getDescription: (workbooks: Set<IWorkbookBase>) => this.getDescription(workbooks),
      notificationIds: ChangeWorkbooksTagsAction.notificationTranslationIds,
      errorDetailFn: (errorItem: IErrorItem<IWorkbookBase>) => this.changeTagsErrorDetail(errorItem)
    });
  }

  private getDescription(workbooks: Set<IWorkbookBase>) {
    return (workbooks.size() === 1)
      ? this.$translate.instant('changeTagsWorkbookDescription', { NAME: L10n.elideIfLong(workbooks.first().name) })
      : this.$translate.instant('changeTagsWorkbooksDescription', { COUNT: workbooks.size() }, L10n.Interpolations.Count);
  }

  public changeTagsErrorDetail(errorItem: IErrorItem<IWorkbookBase>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, WorkbookContentType),
      errorMessage: this.ChangeTagsActionHelper.errorMessageFor(errorItem)
    };
  }

}

Module.instance().service('ChangeWorkbooksTagsAction', ChangeWorkbooksTagsAction);
